import React from "react";

import { faSparkles } from "@awesome.me/kit-4c83d50d0d/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useAddedOrAvailableUntil } from "~/meetingRecorder/utils";
import { openRecapModal } from "~/meetings/MeetingModal/openRecapModal";

import type { EventExtraData } from "./index";

import styles from "./RecordingBanner.module.css";

type Recording = NonNullable<NonNullable<EventExtraData["note"]>["meetingRecordings"]>[0];

/*
 * Banner presenting details about the recording attached to a specific calendar event.
 *
 * If the recording has no associated poster image (which coincides with "the recording is
 * audio-only"), no banner image is displayed.
 */
export default function RecordingBanner({ noteId, recording }: { noteId: string; recording: Recording }) {
	const openModal = React.useCallback(
		(event: React.MouseEvent) => {
			openRecapModal({ noteId, recordingId: recording.id });
			event.stopPropagation();
			event.preventDefault();
		},
		[noteId, recording.id],
	);

	const addedOrAvailableUntil = useAddedOrAvailableUntil(recording);

	const recordingThumbnail = React.useMemo(
		() =>
			recording.meetingRecordedVideoPosterUrl ? (
				<img
					className={styles.recordingThumbnail}
					src={recording.meetingRecordedVideoPosterUrl || ""}
					alt="Recording Preview"
				/>
			) : null,
		[recording.meetingRecordedVideoPosterUrl],
	);
	return (
		<div className={styles.recordingBanner} onClick={openModal}>
			<div className={styles.recordingHeader}>
				<FontAwesomeIcon className={styles.recordingIcon} icon={faSparkles} />
				<span className={styles.recordingTitle}>Meeting Recap</span>
				{addedOrAvailableUntil && <span className={styles.recordingDate}>{addedOrAvailableUntil}</span>}
			</div>

			{recordingThumbnail}
		</div>
	);
}
